import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTopics } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-ink" data-id="element-104" data-mp="9lv00naxu9u9">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-6 text-center sm:pt-10" style={{
      paddingBottom: "11px",
      paddingTop: "7px"
    }} data-id="element-105" data-mp="4lqkazhutj53">
        <h1 className="mx-auto max-w-3xl font-display text-[30px] font-bold uppercase leading-[1.05] text-fog sm:text-5xl" data-id="element-106" data-mp="12861s1aa6gsn">
          Generate <span className="text-gold" data-id="element-107" data-mp="x8jmlmaw6qh7">bulletproof</span> Security reports in{' '}
          <span className="text-gold" data-id="element-108" data-mp="s9ggrzn38g86">seconds</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-[12px] font-bold uppercase tracking-[0.16em] text-fog/70 sm:text-sm" data-id="element-109" data-mp="nczvreb6qhzb">
          The Professional AI Solution to cut paperwork time by 80% with for Security Reports, Daily Operations & Documentation
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-7 w-full max-w-2xl" data-id="element-110" data-mp="3j8iyd2s0imwa">
          <img src="https://cdn.magicpatterns.com/uploads/p3ayfa7nBcgJPYUZbiTRSg/Mockups_de_IA_y_seguridad_privada.webp" alt="100+ AI Prompts for Private Security™ — main system plus the 4 bonus guides shown on tablets" width={1536} height={1024} sizes="(min-width: 640px) 640px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full object-contain drop-shadow-[0_24px_40px_rgba(224,180,76,0.25)]" style={{
          marginTop: "-19px",
          marginBottom: "-19px"
        }} data-id="element-111" data-mp="39cpcutwbfj2d" />
        </motion.div>

        

        <p className="mx-auto mt-4 flex max-w-2xl flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-fog/55" data-id="element-112" data-mp="2hk84a0c7fpfn">
          <span className="text-gold" data-id="element-113" data-mp="s1rsopcm88ut">100+ AI Prompts for Private Security™</span>
          <span aria-hidden="true" data-id="element-114" data-mp="nbbcwylbob5a">·</span>
          <span data-id="element-115" data-mp="na9zingu3cke">6 Volumes + 4 Bonuses</span>
          <span aria-hidden="true" data-id="element-116" data-mp="n98g9vpnzjrl">·</span>
          <span data-id="element-117" data-mp="ibgn6yda9rlt">The SIGMA SMART™ Method</span>
          <span aria-hidden="true" data-id="element-118" data-mp="ia5imwc0kftn">·</span>
          <span className="inline-flex items-center gap-1" data-id="element-119" data-mp="ddnfu208urjy">
            <StarIcon className="h-3 w-3 fill-gold text-gold" aria-hidden="true" data-id="element-120" data-mp="db2ede3uydmq" /> 4.9 · JOIN 500+ officers
          </span>
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-121" data-mp="161ayvclv9a4h">
          <CTAButton href="#pricing" data-id="element-122" data-mp="15zq2dhfzrh3z">See the 100+ AI Prompts for Private Security</CTAButton>

          <p className="mx-auto mt-8 max-w-2xl text-[15px] leading-relaxed text-fog/75 sm:text-lg" data-id="element-123" data-mp="110wqtuk9m06g">
            <span className="font-bold text-fog" data-id="element-124" data-mp="x37bsbv8g5ak">The #1 professional AI toolkit for private security.</span> Designed for
            Security Officers, Supervisors, Site Managers, Team Leaders, and Security Company Operators who want a more
            structured approach to documentation and daily operations.
          </p>

          <h2 className="mx-auto mt-5 max-w-2xl text-[15px] font-bold leading-relaxed text-teal sm:text-lg" data-id="element-125" data-mp="21awdua25atgy">
            {heroTopics.join(' · ')}
          </h2>

          <ul className="mt-6 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-126" data-mp="268of3uoojrxt">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-line bg-ink-2 px-3.5 py-1.5 text-xs font-semibold text-fog/85" data-id="element-127" data-mp="2g0c13g2gwgrw">
                <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-128" data-mp="2p0qn6hn99zwg" />
                {label}
              </li>)}
          </ul>

          <p className="mt-4 text-sm font-medium text-fog/55" data-id="element-129" data-mp="2tyirkb537ehj">
            Everything you need to organize your security AI workflows in one professional toolkit.
          </p>
        </div>

        <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-130" data-mp="zkrbass95wd4">
          🔥 Limited Time Offer · Price will return to $54 soon
        </p>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-fog/55" data-id="element-131" data-mp="3vjrrs73hbnpy">
          <EyeIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-132" data-mp="e77jhs1mpjk4" />
          15 people are viewing this kit right now
        </p>
      </div>
    </header>;
}